import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M22 4.973a8.014 8.014 0 0 1-2.356.662 4.198 4.198 0 0 0 1.804-2.327 8.08 8.08 0 0 1-2.607 1.02A4.047 4.047 0 0 0 15.847 3c-2.265 0-4.102 1.883-4.102 4.207 0 .33.035.65.105.959-3.41-.176-6.433-1.85-8.458-4.398a4.283 4.283 0 0 0-.555 2.117c0 1.46.725 2.748 1.825 3.502a4.028 4.028 0 0 1-1.859-.524v.051c0 2.04 1.415 3.74 3.292 4.125a4.01 4.01 0 0 1-1.852.074c.521 1.671 2.036 2.888 3.832 2.92A8.102 8.102 0 0 1 2 17.777a11.425 11.425 0 0 0 6.29 1.89c7.548 0 11.675-6.41 11.675-11.971 0-.183-.004-.366-.01-.545A8.417 8.417 0 0 0 22 4.973Z",
        }),
      ]
    )
  );
}
